import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BOOKMARKS_FEATURE_KEY, BookmarksState } from './bookmarks.reducer';

export const selectBookmarksState = createFeatureSelector<BookmarksState>(BOOKMARKS_FEATURE_KEY);

export const selectBookmarks = createSelector(selectBookmarksState, (state: BookmarksState) => state.response);

export const selectBookmarksLoaded = createSelector(selectBookmarksState, (state: BookmarksState) => state.loaded);

export const selectBookmarksError = createSelector(selectBookmarksState, (state: BookmarksState) => state.error);
